module.exports = __webpack_public_path__ + "static/img/2.211acbc8.jpg";